export const GET_OTHER_SUCCESS = "GET_OTHER_SUCCESS";
export const GET_OTHER_LOAD = "GET_OTHER_LOAD";
export const GET_OTHER_FAILD = "GET_OTHER_FAILD";
export const GET_ONE_OTHER = "GET_ONE_OTHER";
